export default __webpack_public_path__ + "static/media/BOMProcurement.3f1860a5.svg";